var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"mapLabels",staticClass:"map-labels",class:[
		'map-labels',
		{ 'labels-visible': _vm.labelsVisible === true }
	]},_vm._l((this.labels),function(label){return _c('li',{key:label.id,ref:label.id,refInFor:true,class:[
			{ 'interior-label': label.area === 'interior' },
			{ 'exterior-label': label.area === 'exterior' },
			{ 'bold': label.bold === true },
			{ 'no-code': label.code === null || label.code.length === 0 },
			{ 'visible': label.range.min <= _vm.zoomLevel && label.range.max >= _vm.zoomLevel}
		],style:({
			'font-size' : label.size + 'px',
			'color' : label.color,
			'top' : label.position.y + '%',
			'left' : label.position.x + '%',
			'transform-origin' : '50% 50%',
			'transform' : 'translate(-50%, -50%) scale(' + (_vm.labelScale + label.scaleAdjust) + ')'
		}),on:{"click":function($event){return _vm.selectLabel($event, label.code)}}},[_c('p',{staticClass:"label-stroke",style:({
				'color' : label.outline,
				'text-stroke': '2px ' + label.outline,
				'transform' : 'translate(' + (50 - label.anchor.x) + '%, ' + (50 - label.anchor.y) + '%)'
			})},[_vm._v(_vm._s(label.text))]),_vm._v(" "),_c('p',{staticClass:"label-fill",style:({
				'transform' : 'translate(' + (50 - label.anchor.x) + '%, ' + (50 - label.anchor.y) + '%)'
			})},[_vm._v(_vm._s(label.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }